import axios from "axios";
import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import NavBarUser from "../nav-bar/nav-bar-user";
import FirmProfileForm from "../profileForms/FirmProfileForm";
import PersonalProfileForm from "../profileForms/PersonalProfileForm";

const UserProfile = () => {
  const token = localStorage.getItem("kss_token");
  const [user, setUser] = useState({});

  useEffect(() => {
    if (token) {
      axios
        .get(`https://server.abnca.in/users/single_user`, {
          headers: {
            token: token,
          },
        })
        .then((res) => {
          setUser(res.data);
        })
        .catch((err) => {
          window.alert("some error occured please check console");
          console.log(err);
        });
    } else {
      window.alert("You are not logged in");
      window.location.replace(`https://server.abnca.in/login`);
    }
  }, [token]);
  return (
    <BrowserRouter>
      <NavBarUser user={user} />
      {user.verified ? (
        <div className="container">
          <h1 className="display-3 mt-5  text-center text-primary">
            Your Profile
          </h1>
          <div className="row">
            <div className="col-4 ">
              <div
                className="list-group pt-5 sticky-top"
                id="list-tab"
                role="tablist"
              >
                <a
                  className="list-group-item list-group-item-action active"
                  id="list-home-list"
                  data-toggle="list"
                  href="#list-home"
                  role="tab"
                  aria-controls="home"
                >
                  Personal Profile
                </a>
                <a
                  className="list-group-item list-group-item-action"
                  id="list-profile-list"
                  data-toggle="list"
                  href="#list-profile"
                  role="tab"
                  aria-controls="profile"
                >
                  Firm Profile
                </a>
              </div>
            </div>
            <div className="col-8">
              <div className="tab-content pt-5" id="nav-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="list-home"
                  role="tabpanel"
                  aria-labelledby="list-home-list"
                >
                  <PersonalProfileForm data={user} token={token} />
                </div>
                <div
                  className="tab-pane fade"
                  id="list-profile"
                  role="tabpanel"
                  aria-labelledby="list-profile-list"
                >
                  <FirmProfileForm data={user} token={token} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-5 mx-auto mt-5 card p-5">
              <p className="display-4 text-center text-capitalize ">
                Please verify your Email First
              </p>
              <button className="btn btn-primary">
                Resend Verification Mail
              </button>
            </div>
          </div>
        </div>
      )}
    </BrowserRouter>
  );
};

export default UserProfile;
